<template>
  <div class="custom_index">
    <el-container class="main-panel">
      <el-aside
        v-if="user.userType !== '00'"
        style="width: 215px; overflow: hidden"
        v-show="showAside"
      >
        <ul v-if="showMenu" class="left_url_tab">
          <el-menu
            :default-openeds="openeds"
            :collapse="false"
            default-active="2"
          >
            <el-submenu
              :index="menu.name"
              v-for="(menu, count) in leftMenu"
              :key="count"
            >
              <template slot="title">
                <span style="font-weight:bold;">{{ $enTitle(menu.meta.title) }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  style="padding-left: 48px"
                  @click.native="
                    jumpPage(resolvePath(topPath, menu.path, child.path))
                  "
                  :index="menu.name + '-' + child.name"
                  v-for="(child, index) in menu.children"
                  :key="index"
                  v-show="!child.hidden"
                >
                  {{ $enTitle(child.meta.title) }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </ul>
        <Broadcast :showAside="showAside"></Broadcast>
      </el-aside>
     
      <el-main class="child-content">
        <router-view> </router-view>
      </el-main>
    </el-container>
    <el-backtop :bottom="50" :right="0"></el-backtop>
  </div>
</template>

<script>
import path from "path"
import { mapGetters } from "vuex"
import { getShopList } from "@/api/plat/class"
import Broadcast from "@/components/common/Broadcast"
import imageOrder from "@/assets/images/user/order.png"
import imageAssist from "@/assets/images/user/order_assist.png"
import imageDesign from "@/assets/images/user/design.png"
import imageAmazon from "@/assets/images/user/amazon.png"

export default {
  name: "customIndex",
  components: {
    Broadcast,
  },
  data() {
    return {
      topPath: "",
      openeds: [],
      showMenu: true,
      showAside: true,
      hideAsideList: [
        "/order/myOrder/shopCart",
        "/order/myOrder/settlement",
        "/order/myOrder/getPay",
        "/design/online/designer",
        "/design/online/designerNew",
        "/design/online/designerOther",
        "/design/online/createBatchNew",
        "/map/map_mng/imageMe",
        "/map/map_mng/imageCommon",
        "/map/map_mng/imageShare",
        "/map/map_mng/imageOrder",
        "/map/map_mng/imageSub",
        "/select/custom/list",
        "/select/common/list",
        "/select/selection/list",
        "/product_mng/manage/mapmng",
        "/select/custom/product",
        "/design/online/tool",
        "/order/myOrder/orderLazada",
        "/order/myOrder/orderShopee",
        "/order/myOrder/orderTiktok",
      ],
      imageOrder: imageOrder,
      imageAssist: imageAssist,
      imageDesign: imageDesign,
      imageAmazon: imageAmazon,
    }
  },
  watch: {
    $route(to, from) {
      if (
        to.path === "/select/custom/list" ||
        to.path === "/custom/normal/single" ||
        to.path === "/select/select_mng/list" ||
        to.path === "/select/selection/list" ||
        to.path === "/select/custom/product"
      ) {
        this.showMenu = false
      } else {
        this.showMenu = true
      }
      if (this.hideAsideList.includes(to.path)) {
        this.showAside = false
      } else {
        this.showAside = true
      }
    },
  },
  computed: {
    ...mapGetters(["permission_routes", "user"]),
    leftMenu() {
      if (this.permission_routes[0] && this.permission_routes[0].children) {
        let menus = this.permission_routes[0].children
        let matched = this.$route.matched.filter(
          (item) => item.meta && item.meta.title
        )
        let munuList = matched.filter(
          (item) =>
            item.meta && item.meta.title && item.meta.breadcrumb !== false
        )
        let order = menus.filter((item) => item.path == munuList[0].path)
        this.topPath = order[0].path
        for (let menu of order[0].children) {
          this.openeds.push(menu.name)
        }
        return order[0].children
      }
    },
  },
  created() {
    if (sessionStorage.getItem("orderStatus") == null) {
      this.getDicts("order_status").then((response) => {
        this.$store.commit("SET_ORDERSTATUS", response.data)
        sessionStorage.setItem("orderStatus", JSON.stringify(response.data))
      })
    }
    if (sessionStorage.getItem("shopList") == null) {
      // getShopList().then((response) => {
      //   sessionStorage.setItem("shopList", JSON.stringify(response.data))
      // })
    }
  },
  methods: {
    title2Click(e, url) {
      let _dom = document.querySelector(".li-title_2.title-2-select")
      if (_dom) {
        _dom.classList.toggle("title-2-select") //当class为project的元素上没有这个CSS类时，它就新增这个CSS类；如果class为project的元素有了这个CSS类，它就是删除它。就是反转操作。
      }
      e.target.classList.toggle("title-2-select")
      this.$router.push(url)
    },
    jumpPage(url) {
      this.$router.push(url)
    },
    resolvePath(firstPath, secondPath, thirdPath) {
      return path.resolve(firstPath, secondPath, thirdPath)
    },
  },
  created() {
    if (
      this.$route.path === "/select/custom/list" ||
      this.$route.path === "/custom/normal/single" ||
      this.$route.path === "/select/select_mng/list" ||
      this.$route.path === "/select/selection/list" ||
      this.$route.path === "/select/custom/product"
    ) {
      this.showMenu = false
    } else {
      this.showMenu = true
    }
    if (this.hideAsideList.includes(this.$route.path)) {
      this.showAside = false
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/custom.css";

.child-content {
}

.custom_index {
  width: 100%;

  .el-container {
    height: 100%;
  }
}

.left_url_tab li:not(:last-child) {
  list-style: none;
}

.li-title_1 {
  height: 32px;
  line-height: 32px;
  background-color: #c1c1c154;
  vertical-align: top;
  padding-left: 5px;
  font-weight: 600;
}

.li-title_2 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 20px;
  border-bottom: 1px solid #ccc;

  &:hover {
    background-color: #4934b2;
    color: white;
    cursor: pointer;
  }
}

.li-title_3 {
  height: 28px;
  line-height: 28px;
  vertical-align: top;
  padding-left: 40px;
}

.title-2-select {
  background-color: #4934b2;
  color: white;
  cursor: pointer;
}

.li-help a {
  text-decoration: none;
  color: #4934b2;
}

.s {
  .top-tabs {
    margin-top: 20px;

    .tabs-list {
      display: flex;
      border-bottom: 2px solid #5f9ea0;
      align-items: center;
      height: 50px;
      line-height: 50px;
      background-color: rgb(246, 246, 246);
      border-top-left-radius: 5px;

      .el-divider--vertical {
        margin: initial !important;
      }

      .tab-name {
        height: 50px;
        line-height: 50px;
        text-align: center;
        cursor: pointer;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        padding: 0 20px;
      }
    }
  }
}

.left_url_tab img {
  width: 15px;
  margin: 0 6px 0 0;
}
</style>
